import React, { useEffect } from 'react';
import cn from 'classnames';
import NobleIcon from 'components/nobleIcon';
import './infoDialogBox.scss';
import { getPaymentInformation } from 'services/api/members/getPaymentInfo';

const PaymentInformation = ({ memberId, outsideClickRef }) => {
	const [loading, setLoading] = React.useState(true);
	const [error, setError] = React.useState(null);
	const [data, setData] = React.useState(null);

	useEffect(() => {
		const getMemberInformation = async (memberId) => {
			if (!memberId) {
				setError('Member ID is required');
				setLoading(false);
				return;
			}
			setLoading(true);
			const response = await getPaymentInformation(memberId);
			if (!response.error) {
				console.log('Payment Information:', response);
				setData(response);
				setError(null);
			} else {
				setError(response.error);
			}
			setLoading(false);
		};

		getMemberInformation(memberId);
	}, [memberId]);

	return (
		<div className="DialogBox" ref={outsideClickRef}>
			<div className="DialogBox__speechBubbleTail"></div>
			<div className="DialogBox__content">
				<p className="DialogBox__paragraph">
					{loading && 'Loading...'}
					{data && data?.payment?.message}
					{error && error}
				</p>
			</div>
		</div>
	);
};

export const InfoDialogBox = ({
	memberId,
	toggleDialog,
	setToggleDialog,
	outsideClickRef,
}) => {
	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			if (
				toggleDialog &&
				outsideClickRef.current &&
				!outsideClickRef.current.contains(e.target)
			) {
				setToggleDialog(false);
			}
		};

		document.addEventListener('mousedown', checkIfClickedOutside);

		return () => {
			document.removeEventListener('mousedown', checkIfClickedOutside);
		};
	}, [toggleDialog, outsideClickRef, setToggleDialog]);

	return (
		<div className={cn(['InfoDialogBox', { clicked: toggleDialog }])}>
			<NobleIcon
				onClick={(e) => {
					e.stopPropagation();
					setToggleDialog(true);
				}}
				name="info"
			/>
			{toggleDialog && (
				<PaymentInformation
					memberId={memberId}
					outsideClickRef={outsideClickRef}
				/>
			)}
		</div>
	);
};
